import { __assign } from "tslib";
import { SchemaActionType } from '@tencent/memoire-core';
import { UnimplementedError } from '@tencent/memoire-error-utils';
import { UnexpectedOutsideMigrationActionError } from '../errors';
var IndexBuilder = /** @class */ (function () {
    function IndexBuilder(name, context) {
        this.name = name;
        this.context = context;
    }
    IndexBuilder.create = function (context) {
        return {
            index: function (name) {
                return new IndexBuilder(name, context);
            },
        };
    };
    IndexBuilder.prototype.create = function (attributes) {
        var collection = this.context.scope.collection;
        if (!collection) {
            throw new UnexpectedOutsideMigrationActionError('CreateIndex');
        }
        this.context.actions.schema.push({
            type: SchemaActionType.CreateIndex,
            name: this.name,
            attributes: __assign({}, attributes),
            collection: collection,
        });
        return this;
    };
    IndexBuilder.prototype.drop = function () {
        var collection = this.context.scope.collection;
        if (!collection) {
            throw new UnexpectedOutsideMigrationActionError('DropIndex');
        }
        this.context.actions.schema.push({ type: SchemaActionType.DropIndex, name: this.name, collection: collection });
    };
    IndexBuilder.prototype.alter = function (attributes) {
        var collection = this.context.scope.collection;
        if (!collection) {
            throw new UnexpectedOutsideMigrationActionError('AlterIndex');
        }
        this.context.actions.schema.push({ type: SchemaActionType.DropIndex, name: this.name, collection: collection }, { type: SchemaActionType.CreateIndex, name: this.name, attributes: __assign({}, attributes), collection: collection });
        return this;
    };
    IndexBuilder.prototype.rename = function (name) {
        var collection = this.context.scope.collection;
        if (!collection) {
            throw new UnexpectedOutsideMigrationActionError('RenameIndex');
        }
        this.context.actions.schema.push({ type: SchemaActionType.DropIndex, name: this.name, collection: collection }, 
        // TODO: use current attrs to rebuild Index
        { type: SchemaActionType.CreateIndex, name: name, attributes: { path: '' }, collection: collection });
    };
    IndexBuilder.prototype.ensure = function () {
        throw new UnimplementedError();
    };
    return IndexBuilder;
}());
export default IndexBuilder;
//# sourceMappingURL=index-builder.js.map